// import React, { useContext, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../context/Authcontext";

// import ForgotPassword from "../views/components/ForgotPassword";
// import ToastMessage from "../views/components/ToastMessage";



// export default function LoginReg({
//   active,
//   setactive,
//   regactive,
//   setregactive,
// }) {
//   const [registerFormData, setRegisterFormData] = useState({
//     username: "",
//     phoneNumber: "",
//     pwd: "",
//     cpassword: "",
//     invitecode: "",
//     imOver18: false,
//     iAcceptAll: false,
//   });
//   const navigate = useNavigate();

//   const [loginFormData, setLoginFormData] = useState({
//     phoneNumber: "",
//     password: "",
//     iAcceptAll: true,
//   });
//   const { Register, login, setIsAuthenticated } = useContext(AuthContext);
//   const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
//   const [isPassVisible, setPassVisible] = useState(false);
//   const [isConfPassViss, setConfPassVisible] = useState(false);
//   const [loading, setLoading] = useState(false); // Added loading state



//   const handleForgotPasswordClick = () => {
//     // Close login modal before opening forgot password
//     setactive(false);
//     setForgotPasswordActive(true);
//   };
//   const handleCloseForgotPassword = () => {
//     setForgotPasswordActive(false);
//     // Optionally reopen login modal
//     setactive(true);
//   };
//   const handleclearRegisterForm = () => {
//     setRegisterFormData({
//       username: "",
//       phoneNumber: "",
//       pwd: "",
//       cpassword: "",
//       invitecode: "",
//       imOver18: false,
//       iAcceptAll: false,
//     });
//   };
//   const handleclearLoginForm = () => {
//     setLoginFormData({
//       phoneNumber: "",
//       password: "",
//       iAcceptAll: false,
//     });
//   };
//   const submitregister = (e) => {


//     e.preventDefault();
//     if (
//       !registerFormData.username ||
//       !registerFormData.phoneNumber ||
//       !registerFormData.cpassword ||
//       !registerFormData.pwd ||
//       !registerFormData.imOver18 ||
//       !registerFormData.iAcceptAll
//     ) {
//       ToastMessage(0, "All fields are required!");
//       return;
//     }
//     let { imOver18, iAcceptAll, ...data } = registerFormData;

//     Register(data, function (res) {
//       if (res.status) {
//         ToastMessage(1, res.message);
//         handleclearRegisterForm();
//         // navigate('/'); 
//         setactive(true);
//         setregactive(false);

//       } else {
//         ToastMessage(0, res.message);
//       }
//     });
//   };

//   const submitlogin = (e) => {
//     e.preventDefault();
//     if (!loginFormData.phoneNumber || !loginFormData.password) {
//       ToastMessage(0, "All fields are required!");
//       return;
//     }
//     if(!loginFormData.iAcceptAll){
//       ToastMessage(0,"Please Accept The Terms And Conditions");
//       return;
//     }
//     let { iAcceptAll, ...data } = loginFormData;
//     login(data, function (res) {
//       if (res.status) {
//         setIsAuthenticated(true);
//         ToastMessage(1, res.message);
//         handleclearLoginForm();

//         setactive(false);
//         setregactive(false);
//         navigate('/'); 

//       } else {
//         ToastMessage(0, res.message);
//       }
//     });
//   };

//   const handleDemoLogin = async () => {
//     setLoading(true);
//     const demoCredentials = {
//       phoneNumber: "9999999999",
//       password: "123456",
//     };
//     login(demoCredentials, function (res) {
//       setLoading(false);
//       if(res.status){
//         setIsAuthenticated(true);
//         ToastMessage(1, res.message);
//         setactive(false);
//         setregactive(false);
//         navigate("/");
//       } else {
//         ToastMessage(0, res.message);
//       }
//     })
// }

//   return (
//     <>
//       {/* Login section */}
//       <section
//         style={{ zIndex: 1050 }}
//         aria-hidden="true"
//         className={`modal-backdrop fade show ${active ? "d-block" : "d-none"} `}
//       ></section>
//       <section
//         role="dialog"
//         tabIndex="-1"
//         aria-modal="true"
//         className={`modal fade show ${active ? "d-block" : "d-none"} `}
//       >
//         <div
//           role="document"
//           className="modal-dialog"
//           style={{
//             display: "flex",
//             alignItems: "center",
//             borderRadius: "13px",
//           }}
//         >
//           <div className="modal-content">
//           {/* <div> */}
//             <div _ngcontent-crs-c59="" appclickoutside="" className="">
//               <button
//                 _ngcontent-crs-c59=""
//                 type="button"
//                 onClick={() => setactive(false)}
//                 className="close modal-close-button"
//               >
//                 <i className="bi bi-x cross_icon text-white"></i>
//               </button>
//               <div _ngcontent-crs-c59="" className="px-5 form-box py-5">
//                 <div
//                   _ngcontent-crs-c59=""
//                   className="text-center header-box d-flex align-items-center justify-content-center"
//                 >
//                   <img
//                     _ngcontent-crs-c59=""
//                     className="top_dark logo-img"
//                     alt="logo"
//                     src="/assets/images/KheloyarnetLogo.svg"
//                   />
//                 </div>
//                 <form
//                   _ngcontent-crs-c59=""
//                   onSubmit={submitlogin}
//                   noValidate=""
//                   className="ng-untouched ng-pristine ng-invalid"
//                 >
//                   <div _ngcontent-crs-c59="" className="pt-5">
//                     <span
//                       _ngcontent-crs-c59=""
//                       className="d-flex align-items-center form-floating"
//                     >
//                       <input
//                         _ngcontent-crs-c59=""
//                         autoComplete="username"
//                         value={loginFormData.phoneNumber}
//                         onChange={(e) =>
//                           setLoginFormData({
//                             ...loginFormData,
//                             phoneNumber: e.target.value.replace(/[^0-9]/, ""),
//                           })
//                         }
//                         formcontrolname="username"
//                         className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                         style={{ height: "43px !important" }}
//                         placeholder="Mobile No"
//                         maxLength={10}
//                       />
//                       <label _ngcontent-crs-c59="" className="floating-label">
//                         Mobile No
//                       </label>
//                     </span>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-3">
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <span
//                         _ngcontent-crs-c59=""
//                         className="d-flex align-items-center form-floating"
//                       >
//                         <div
//                           className={`p_hide_icon ${
//                             isPassVisible ? "d-none" : ""
//                           }`}
//                           onClick={() => setPassVisible(!isPassVisible)}
//                         >
//                           <i className="bi bi-eye-slash"></i>
//                         </div>
//                         <div
//                           className={`p_hide_icon ${
//                             isPassVisible ? "" : "d-none"
//                           }`}
//                           onClick={() => setPassVisible(!isPassVisible)}
//                         >
//                           <i className="bi bi-eye-fill"></i>
//                         </div>
//                         <input
//                           _ngcontent-crs-c59=""
//                           value={loginFormData.password}
//                           onChange={(e) =>
//                             setLoginFormData({
//                               ...loginFormData,
//                               password: e.target.value,
//                             })
//                           }
//                           formcontrolname="password"
//                           className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                           placeholder="Password"
//                           type={isPassVisible ? "text" : "password"}
//                         />
//                         <label _ngcontent-crs-c59="" className="floating-label">
//                           Password
//                         </label>
//                       </span>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-crs-c59=""
//                     className="pt-3 input_field_with_logo"
//                   >
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <div
//                         _ngcontent-crs-c59=""
//                         className="policy row gap-1"
//                         style={{ flexWrap: "nowrap" }}
//                       >
//                         <input
//                           className="col-md-1 form-check-input shadow-none border-0 mb-1"
//                           type="checkbox"
//                           id="imover18_1"
//                           checked={loginFormData.iAcceptAll}
//                           onChange={(e) =>
//                             setLoginFormData({
//                               ...loginFormData,
//                               iAcceptAll: e.target.checked,
//                             })
//                           }
//                         />
//                         <h3
//                           _ngcontent-crs-c59=""
//                           className="col-md-11 text-center"
//                         >
//                           {" "}
//                           I accept all the{" "}
//                           <Link
//                             _ngcontent-crs-c59=""
//                             routerlinkactive="router-link-active"
//                             style={{ textDecoration: "underline" }}
//                           >
//                             {" "}
//                             Terms &amp; Conditions
//                           </Link>
//                         </h3>
//                       </div>
//                       <p
//                         className="loginLink m-0 text-right ng-star-inserted"
//                         onClick={handleForgotPasswordClick}
//                       >
//                         <Link
//                           style={{
//                             position: "relative",
//                             color: themeColors['--text-color) !important",
//                           }}
//                         >
//                           Forgot Password?
//                         </Link>
//                       </p>
//                     </div>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-3">
//                     <button
//                       _ngcontent-crs-c59=""
//                       type="submit"
//                       className="login-btn"
//                     >
//                       Login{" "}
//                     </button>
//                   </div>
//                 </form>
//                 <div _ngcontent-crs-c59="" className="pt-3">
//                   <button
//                     _ngcontent-crs-c59=""
//                     type="submit"
//                     className="login-btn"
//                     onClick={handleDemoLogin}
//                   >
//                     Demo
//                   </button>
//                 </div>
//                 <div _ngcontent-crs-c59="" className="pt-3">
//                   <button
//                     _ngcontent-crs-c59=""
//                     type="submit"
//                     className="login-btn1  d-flex justify-content-center gap-3   "
//                   >
//                     <i class="bi bi-android2 text-white"></i>
//                     <p style={{ marginTop: "5px" }}>Download App</p>
//                   </button>
//                 </div>
//                 <div _ngcontent-crs-c59="" className="bottom_create">
//                   <p
//                     _ngcontent-crs-c59=""
//                     className="signup_add"
//                     onClick={() => navigate("/registerPage")}
//                   >
//                     Create New Account
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <ForgotPassword
//         forgotPasswordActive={forgotPasswordActive}
//         setForgotPasswordActive={handleCloseForgotPassword}
//         onClose={handleCloseForgotPassword}
//       />

//       {/* Registration Section */}
//       <section
//         style={{ zIndex: 1050 }}
//         aria-hidden="true"
//         className={`modal-backdrop fade show ${
//           regactive ? "d-block" : "d-none"
//         } `}
//       ></section>
//       <section
//         role="dialog"
//         tabIndex="-1"
//         aria-modal="true"
//         className={`modal fade show ${regactive ? "d-block" : "d-none"} `}
//       >
//         <div role="document" className="modal-dialog">
//           <div className="modal-content">
//             <div
//               _ngcontent-crs-c59=""
//               appclickoutside=""
//               className="modal-body"
//             >
//               <button
//                 _ngcontent-crs-c59=""
//                 type="button"
//                 onClick={() => setregactive(false)}
//                 className="close modal-close-button"
//               >
//                 <i className="bi bi-x cross_icon"></i>
//               </button>
//               <div _ngcontent-crs-c59="" className="px-5 form-box py-5">
//                 <div
//                   _ngcontent-crs-c59=""
//                   className="text-center header-box d-flex align-items-center justify-content-center"
//                 >
//                   <span>SIGN UP</span>
//                 </div>
//                 <form
//                   _ngcontent-crs-c59=""
//                   onSubmit={submitregister}
//                   noValidate=""
//                   className="ng-untouched ng-pristine ng-invalid"
//                 >
//                   <div _ngcontent-crs-c59="" className="pt-3">
//                     <span
//                       _ngcontent-crs-c59=""
//                       className="d-flex align-items-center form-floating"
//                     >
//                       <input
//                         _ngcontent-crs-c59=""
//                         autoComplete="username"
//                         value={registerFormData.username}
//                         onChange={(e) =>
//                           setRegisterFormData({
//                             ...registerFormData,
//                             username: e.target.value,
//                           })
//                         }
//                         formcontrolname="username"
//                         className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                         placeholder="Username"
//                       />
//                       <label _ngcontent-crs-c59="" className="floating-label">
//                         User Name
//                       </label>
//                     </span>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <span
//                       _ngcontent-crs-c59=""
//                       className="d-flex align-items-center form-floating"
//                     >
//                       <input
//                         _ngcontent-crs-c59=""
//                         maxLength={10}
//                         value={registerFormData.phoneNumber}
//                         onChange={(e) =>
//                           setRegisterFormData({
//                             ...registerFormData,
//                             phoneNumber: e.target.value.replace(/[^0-9]/, ""),
//                           })
//                         }
//                         formcontrolname="username"
//                         className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                         placeholder="Username"
//                       />
//                       <label _ngcontent-crs-c59="" className="floating-label">
//                         Mobile No
//                       </label>
//                     </span>
//                   </div>

//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <span
//                         _ngcontent-crs-c59=""
//                         className="d-flex align-items-center form-floating"
//                       >
//                         <div
//                           className={`p_hide_icon ${
//                             isPassVisible ? "d-none" : ""
//                           }`}
//                           onClick={() => setPassVisible(!isPassVisible)}
//                         >
//                           <i className="bi bi-eye-slash"></i>
//                         </div>
//                         <div
//                           className={`p_hide_icon ${
//                             isPassVisible ? "" : "d-none"
//                           }`}
//                           onClick={() => setPassVisible(!isPassVisible)}
//                         >
//                           <i className="bi bi-eye-fill"></i>
//                         </div>
//                         <input
//                           _ngcontent-crs-c59=""
//                           autoComplete="current-password"
//                           value={registerFormData.pwd}
//                           onChange={(e) =>
//                             setRegisterFormData({
//                               ...registerFormData,
//                               pwd: e.target.value,
//                             })
//                           }
//                           formcontrolname="password"
//                           className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                           placeholder="Password"
//                           type={isPassVisible ? "text" : "password"}
//                         />
//                         <label _ngcontent-crs-c59="" className="floating-label">
//                           Password
//                         </label>
//                       </span>
//                     </div>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <span
//                         _ngcontent-crs-c59=""
//                         className="d-flex align-items-center form-floating"
//                       >
//                         <div
//                           className={`p_hide_icon ${
//                             isConfPassViss ? "d-none" : ""
//                           }`}
//                           onClick={() => setConfPassVisible(!isConfPassViss)}
//                         >
//                           <i className="bi bi-eye-slash"></i>
//                         </div>
//                         <div
//                           className={`p_hide_icon ${
//                             isConfPassViss ? "" : "d-none"
//                           }`}
//                           onClick={() => setConfPassVisible(!isConfPassViss)}
//                         >
//                           <i className="bi bi-eye-fill"></i>
//                         </div>

//                         <input
//                           _ngcontent-crs-c59=""
//                           autoComplete="current-password"
//                           value={registerFormData.cpassword}
//                           onChange={(e) =>
//                             setRegisterFormData({
//                               ...registerFormData,
//                               cpassword: e.target.value,
//                             })
//                           }
//                           formcontrolname="password"
//                           className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                           placeholder="Password"
//                           type={isConfPassViss ? "text" : "password"}
//                         />
//                         <label _ngcontent-crs-c59="" className="floating-label">
//                           Confirm Password
//                         </label>
//                       </span>
//                     </div>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <span
//                       _ngcontent-crs-c59=""
//                       className="d-flex align-items-center form-floating"
//                     >
//                       <span _ngcontent-crs-c59="" className="user_icon">
//                         <svg
//                           _ngcontent-crs-c59=""
//                           className="svg-inline--fa fa-user fa-w-14"
//                           aria-hidden="true"
//                           focusable="false"
//                           data-prefix="fa"
//                           data-icon="user"
//                           role="img"
//                           xmlns="http://www.w3.org/2000/svg"
//                           viewBox="0 0 448 512"
//                           data-fa-i2svg=""
//                         >
//                           <path
//                             fill="currentColor"
//                             d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
//                           ></path>
//                         </svg>
//                       </span>
//                       <input
//                         _ngcontent-crs-c59=""
//                         type="text"
//                         value={registerFormData.invitecode}
//                         onChange={(e) =>
//                           setRegisterFormData({
//                             ...registerFormData,
//                             invitecode: e.target.value,
//                           })
//                         }
//                         formcontrolname="username"
//                         className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                         placeholder="Username"
//                       />
//                       <label _ngcontent-crs-c59="" className="floating-label">
//                         Invitation Code
//                       </label>
//                     </span>
//                   </div>
//                   <div
//                     _ngcontent-crs-c59=""
//                     className="pt-3 input_field_with_logo"
//                   >
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <div className="form-check">
//                         <input
//                           className="col-md-1 form-check-input shadow-none border-0"
//                           type="checkbox"
//                           onChange={(e) =>
//                             setRegisterFormData({
//                               ...registerFormData,
//                               imOver18: e.target.checked,
//                             })
//                           }
//                           checked={registerFormData.imOver18}
//                           id="imover18"
//                         />
//                         <label
//                           className="form-check-label text-white"
//                           htmlFor="imover18"
//                         >
//                           I'm over 18
//                         </label>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-crs-c59=""
//                     className="pt-2 input_field_with_logo"
//                   >
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <div className="form-check">
//                         <input
//                           className="col-md-1 form-check-input shadow-none border-0"
//                           type="checkbox"
//                           onChange={(e) =>
//                             setRegisterFormData({
//                               ...registerFormData,
//                               iAcceptAll: e.target.checked,
//                             })
//                           }
//                           checked={registerFormData.iAcceptAll}
//                           id="iaccept"
//                         />
//                         <label
//                           className="form-check-label text-white"
//                           htmlFor="iaccept"
//                         >
//                           I accept all the
//                         </label>
//                         <Link
//                           className="ms-2 cursor-pointer"
//                           style={{ textDecoration: "underline" }}
//                         >
//                           Terms &amp; Conditions
//                         </Link>
//                       </div>
//                     </div>
//                   </div>

//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <button
//                       _ngcontent-crs-c59=""
//                       type="submit"
//                       className="login-btn"
//                     >
//                       Register
//                     </button>
//                   </div>
//                 </form>
//                 <div _ngcontent-crs-c59="" className="bottom_create">
//                   <p
//                     _ngcontent-crs-c59=""
//                     className="addition_className ng-star-inserted"
//                   >
//                     <Link
//                       _ngcontent-crs-c59=""
//                       style={{ textDecoration: "underline" }}
//                     >
//                       Already have an account?
//                     </Link>
//                   </p>
//                   <p
//                     _ngcontent-crs-c59=""
//                     onClick={() => {
//                       setactive(true);
//                       setregactive(false);
//                     }}
//                     className="signup_add"
//                   >
//                     Login
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }


import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext, base_url } from "../context/Authcontext";
import ForgotPassword from "../views/components/ForgotPassword";
import ToastMessage from "../views/components/ToastMessage";
import "../assets/AdminCss/auth-form.css";
import { useTheme } from "../context/ThemeContext";
import MarqueeBottom from "./components/MarqueeBottom";
import { LuLogIn } from "react-icons/lu";
import { FaUser } from "react-icons/fa";
import { FaKey } from "react-icons/fa";
import { FaHandPointDown } from "react-icons/fa";
import axios from "axios";

export default function LoginReg({
  active,
  setactive,
  regactive,
  setregactive,
}) {
  const [registerFormData, setRegisterFormData] = useState({
    username: "",
    phoneNumber: "",
    pwd: "",
    cpassword: "",
    invitecode: "",
    imOver18: false,
    iAcceptAll: false,
  });
  const navigate = useNavigate();
  const { themeColors } = useTheme();

  const [loginFormData, setLoginFormData] = useState({
    phoneNumber: "",
    password: "",
    iAcceptAll: true,
  });
  const { Register, login, isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
  const [isPassVisible, setPassVisible] = useState(false);
  const [isConfPassViss, setConfPassVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logoPath, setLogoPath] = useState('');

  const isSmallScreen = window.innerWidth <= 768;
  const styles = {
    logo_div: {
      height: isSmallScreen ? '70px' : '130px',
      width: isSmallScreen ? '100%' : '100%',
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    logo_img: {
      height: isSmallScreen ? '70px' : '130px',
      width: isSmallScreen ? '116px' : '205px',
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    loginIcon: {
      height: '19px',
      width: '19px',
      fontWeight: 'bold',
    }
  };

  const handleForgotPasswordClick = () => {
    setactive(false);
    setForgotPasswordActive(true);
  };
  const handleCloseForgotPassword = () => {
    setForgotPasswordActive(false);
    setactive(true);
  };
  const handleclearRegisterForm = () => {
    setRegisterFormData({
      username: "",
      phoneNumber: "",
      pwd: "",
      cpassword: "",
      invitecode: "",
      imOver18: false,
      iAcceptAll: false,
    });
  };

  const handleclearLoginForm = () => {
    setLoginFormData({
      phoneNumber: "",
      password: "",
      iAcceptAll: false,
    });
  };
  const submitregister = (e) => {
    e.preventDefault();
    if (
      !registerFormData.username ||
      !registerFormData.phoneNumber ||
      !registerFormData.cpassword ||
      !registerFormData.pwd ||
      !registerFormData.imOver18 ||
      !registerFormData.iAcceptAll
    ) {
      ToastMessage(0, "All fields are required!");
      return;
    }
    let { imOver18, iAcceptAll, ...data } = registerFormData;

    Register(data, function (res) {
      if (res.status) {
        ToastMessage(1, res.message);
        handleclearRegisterForm();
        setactive(true);
        setregactive(false);
      } else {
        ToastMessage(0, res.message);
      }
    });
  };

  const submitlogin = (e) => {
    e.preventDefault();
    if (!loginFormData.phoneNumber || !loginFormData.password) {
      ToastMessage(0, "All fields are required!");
      return;
    }
    if (!loginFormData.iAcceptAll) {
      ToastMessage(0, "Please Accept The Terms And Conditions");
      return;
    }
    let { iAcceptAll, ...data } = loginFormData;
    login(data, function (res) {
      if (res.status) {
        setIsAuthenticated(true);
        ToastMessage(1, res.message);
        handleclearLoginForm();
        // setactive(false);
        // setregactive(false);
        navigate("/");
      } else {
        ToastMessage(0, res.message);
      }
    });
  };

  const showLogo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/fetchLogoAction', {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response.data.data.result[0];

      console.log("Fetched logo data:", data);

      if (data && data.logo_image) {
        setLogoPath(data.logo_image);
      }

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    showLogo();
  }, []);

  const handleDemoLogin = async () => {
    // setLoading(true);
    const demoCredentials = {
      phoneNumber: "7410258963",
      password: "123456", 
    };
    login(demoCredentials, function (res) {
      // setLoading(false);
      if (res.status) {
        setIsAuthenticated(true);
        ToastMessage(1, res.message);
        navigate("/home");
      } else {
        ToastMessage(0, res.message);
      }
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home", { replace: true })
    } else {
      navigate("/login", { replace: true })
    }
  }, [isAuthenticated]);

  return (
    <>
      {/* Login Section */}
      <div
        className={`auth-backdrop ${active ? "auth-visible" : "auth-hidden"}`}
      ></div>
      <div
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className={`auth-modal1 ${active ? "auth-visible" : "auth-hidden"}`}
        style={{ overflowY: "auto" }}
      >
        <div className="auth-modal-dialog">
          <div style={styles.logo_div}>
            <img src="https://sitethemedata.com/sitethemes/goid9.com/front/logo.png" className="img-fluid" style={styles.logo_img} />
          </div>
          <div className="auth-modal-content mt-4">
            {/* <button
              type="button"
              onClick={() => setactive(false)} 
              className="auth-close-button"
            >
              <i className="bi bi-x auth-cross-icon"></i>
            </button> */}
            <div className="auth-form-box">
              <div className="auth-header-box">
                {/* <img
                  className="auth-logo-img"
                  alt="logo"
                  src="/assets/images/KheloyarnetLogo.svg"
                /> */}
                <h4 style={{ color: "#000" }}>LOGIN <FaHandPointDown style={{ color: "#000", fontSize: "22px" }} /></h4>
              </div>
              <form onSubmit={submitlogin} noValidate className="auth-form">
                <div className="auth-input-group">
                  <div className="auth-form-floating d-flex">
                    <input
                      autoComplete="username"
                      value={loginFormData.phoneNumber}
                      placeholder="User Name"
                      onChange={(e) =>
                        setLoginFormData({
                          ...loginFormData,
                          phoneNumber: e.target.value,
                        })
                      }
                      className="auth-input"/>  
                      <div className="login_inputField"><FaUser style={{ color: "black", fontSize: "17px" }} /></div>
                  </div>
                </div>
                <div className="auth-input-group">
                  <div className="auth-form-floating auth-password-field d-flex">

                    <input
                      value={loginFormData.password}
                      placeholder="Password"
                      onChange={(e) =>
                        setLoginFormData({
                          ...loginFormData,
                          password: e.target.value,
                        })
                      }
                      className="auth-input"

                      type={isPassVisible ? "text" : "password"}
                    />
                    {/* <div
                      className={`auth-eye-icon ${isPassVisible ? "auth-hidden" : ""
                        }`}
                      onClick={() => setPassVisible(!isPassVisible)}
                    >
                      <i className="bi bi-eye-slash"></i>
                    </div>
                    <div
                      className={`auth-eye-icon ${isPassVisible ? "" : "auth-hidden"
                        }`}
                      onClick={() => setPassVisible(!isPassVisible)}
                    >
                      <i className="bi bi-eye-fill"></i>
                    </div> */}
                    <div className="login_inputField"><FaKey style={{ color: "black", fontSize: "17px" }} /></div>
                  </div>
                </div>

                <div className="auth-input-group d-flex my-2">
                  <div className="auth-policy-group d-none">
                    <input
                      className="auth-checkbox"
                      type="checkbox"
                      id="login-terms"
                      checked={loginFormData.iAcceptAll}
                      onChange={(e) =>
                        setLoginFormData({
                          ...loginFormData,
                          iAcceptAll: e.target.checked,
                        })
                      }
                    />
                    <label htmlFor="login-terms" style={{ color: themeColors['--dark-theme-white-color'] }} className="auth-policy-label ms-2">
                      I accept all the{" "}
                      <Link
                        className="auth-link"
                        style={{
                          textDecoration: "underline",
                          color: "blue !important",
                        }}
                      >
                        Terms & Conditions
                      </Link>
                    </label>
                  </div>
                  {/* <p
                    className="auth-forgot-link mt-0"
                    onClick={handleForgotPasswordClick}
                  >
                    <Link className="auth-link text-nowrap">Forgot Password?</Link>
                  </p> */}
                </div>
                <div className="auth-input-group mb-2">
                  <button type="submit" className="auth-button d-flex">
                    <div className="ms-auto">Login</div> <div className="ms-auto"><LuLogIn style={styles.loginIcon} /></div>
                  </button>
                </div>
                <div className="auth-input-group mb-1">
                  <button
                    type="button"
                    className="auth-button d-flex"
                    onClick={handleDemoLogin}
                    disabled={loading}
                  >
                    <><div className="ms-auto">Login with demo ID</div> <div className="ms-auto"><LuLogIn style={styles.loginIcon} /></div></>
                  </button>
                </div>
                {/* <div className="auth-input-group">
                  <button type="button" className="auth-download-button">
                    <i className="bi bi-android2 auth-icon"></i>
                    <span>Download App</span>
                  </button>

                </div> */}
                <div className="auth-footer">
                  {/* <p
                    className="auth-signup-link"
                    onClick={() => navigate("/registerPage")}
                  >
                    Create New Account
                  </p> */}
                  <p className="mb-1">This site is protected by reCAPTCHA and the Google <span className="policy_text">Privacy Policy</span> and <span className="policy_text">Terms of Service</span> apply.</p>
                </div>
              </form>
            </div>
          </div>
        </div>
        <MarqueeBottom />
      </div>

      <ForgotPassword
        forgotPasswordActive={forgotPasswordActive}
        setForgotPasswordActive={handleCloseForgotPassword}
        onClose={handleCloseForgotPassword}
      />

      {/* Registration Section */}
      <div
        className={`auth-backdrop ${regactive ? "auth-visible" : "auth-hidden"
          }`}
      ></div>
      <div
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className={`auth-modal ${regactive ? "auth-visible" : "auth-hidden"}`}
      >
        <div className="auth-modal-dialog">
          <div className="auth-modal-content">
            <button
              type="button"
              onClick={() => setregactive(false)}
              className="auth-close-button"
            >
              <i className="bi bi-x auth-cross-icon"></i>
            </button>
            <div className="auth-form-box">
              <div className="auth-header-box">
                <span>SIGN UP</span>
              </div>
              <form onSubmit={submitregister} noValidate className="auth-form">
                <div className="auth-input-group">
                  <div className="auth-form-floating">
                    <input
                      autoComplete="username"
                      value={registerFormData.username}
                      onChange={(e) =>
                        setRegisterFormData({
                          ...registerFormData,
                          username: e.target.value,
                        })
                      }
                      className="auth-input"
                      placeholder="Username"
                    />
                    <label className="auth-floating-label">User Name</label>
                  </div>
                </div>
                <div className="auth-input-group">
                  <div className="auth-form-floating">
                    <input
                      maxLength={10}
                      value={registerFormData.phoneNumber}
                      onChange={(e) =>
                        setRegisterFormData({
                          ...registerFormData,
                          phoneNumber: e.target.value.replace(/[^0-9]/, ""),
                        })
                      }
                      className="auth-input"
                      placeholder="Mobile No"
                    />
                    <label className="auth-floating-label">Mobile No</label>
                  </div>
                </div>
                <div className="auth-input-group">
                  <div className="auth-form-floating auth-password-field">
                    <div
                      className={`auth-eye-icon ${isPassVisible ? "auth-hidden" : ""
                        }`}
                      onClick={() => setPassVisible(!isPassVisible)}
                    >
                      <i className="bi bi-eye-slash"></i>
                    </div>
                    <div
                      className={`auth-eye-icon ${isPassVisible ? "" : "auth-hidden"
                        }`}
                      onClick={() => setPassVisible(!isPassVisible)}
                    >
                      <i className="bi bi-eye-fill"></i>
                    </div>
                    <input
                      autoComplete="current-password"
                      value={registerFormData.pwd}
                      onChange={(e) =>
                        setRegisterFormData({
                          ...registerFormData,
                          pwd: e.target.value,
                        })
                      }
                      className="auth-input"

                      type={isPassVisible ? "text" : "password"}
                    />
                    <label className="auth-floating-label">Password</label>
                  </div>
                </div>
                <div className="auth-input-group">
                  <div className="auth-form-floating auth-password-field">
                    <div
                      className={`auth-eye-icon ${isConfPassViss ? "auth-hidden" : ""
                        }`}
                      onClick={() => setConfPassVisible(!isConfPassViss)}
                    >
                      <i className="bi bi-eye-slash"></i>
                    </div>
                    <div
                      className={`auth-eye-icon ${isConfPassViss ? "" : "auth-hidden"
                        }`}
                      onClick={() => setConfPassVisible(!isConfPassViss)}
                    >
                      <i className="bi bi-eye-fill"></i>
                    </div>
                    <input
                      autoComplete="current-password"
                      value={registerFormData.cpassword}
                      onChange={(e) =>
                        setRegisterFormData({
                          ...registerFormData,
                          cpassword: e.target.value,
                        })
                      }
                      className="auth-input"
                      placeholder="Confirm Password"
                      type={isConfPassViss ? "text" : "password"}
                    />
                    <label className="auth-floating-label">
                      Confirm Password
                    </label>
                  </div>
                </div>
                <div className="auth-input-group">
                  <div className="auth-form-floating auth-icon-field">
                    <span className="auth-user-icon">
                      <svg
                        className="auth-svg-icon"
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fa"
                        data-icon="user"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                        ></path>
                      </svg>
                    </span>
                    <input
                      type="text"
                      value={registerFormData.invitecode}
                      // value={register.formData.invitecode}
                      onChange={(e) =>
                        setRegisterFormData({
                          ...registerFormData,
                          invitecode: e.target.value,
                        })
                      }
                      className="auth-input"
                      placeholder="Invitation Code"
                    />
                    <label className="auth-floating-label">
                      Invitation Code
                    </label>
                  </div>
                </div>
                <div className="auth-input-group">
                  <div className="auth-checkbox-group">
                    <input
                      className="auth-checkbox"
                      type="checkbox"
                      id="reg-over18"
                      checked={registerFormData.imOver18}
                      onChange={(e) =>
                        setRegisterFormData({
                          ...registerFormData,
                          imOver18: e.target.checked,
                        })
                      }
                    />
                    <label htmlFor="reg-over18" className="auth-checkbox-label">
                      I'm over 18
                    </label>
                  </div>
                </div>
                <div className="auth-input-group">
                  <div className="auth-checkbox-group">
                    <input
                      className="auth-checkbox"
                      type="checkbox"
                      id="reg-terms"
                      checked={registerFormData.iAcceptAll}
                      onChange={(e) =>
                        setRegisterFormData({
                          ...registerFormData,
                          iAcceptAll: e.target.checked,
                        })
                      }
                    />
                    <label htmlFor="reg-terms" className="auth-checkbox-label">
                      I accept all the{" "}
                      <Link
                        className="auth-link"
                        style={{
                          textDecoration: "underline",
                          color: "#FFCC00",
                        }}
                      >
                        Terms & Conditions
                      </Link>
                    </label>
                  </div>
                </div>
                <div className="auth-input-group">
                  <button type="submit" className="auth-button">
                    Register
                  </button>
                </div>
                <div className="auth-footer">
                  <p className="auth-login-link">
                    <Link
                      className="auth-link"
                      style={{ textDecoration: "underline" }}
                    >
                      Already have an account?
                    </Link>
                  </p>
                  <p
                    className="auth-signup-link"
                    onClick={() => {
                      setactive(true);
                      setregactive(false);
                    }}
                  >
                    Login
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}